export const language = {
	title: 'Career Highlights',
};
